// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import MaskController from "./mask_controller";
import QuoteFormController from "./quote_form_controller";
import HelloController from "./hello_controller";
import ReactComponentController from "./react_component_controller.jsx";
import SlimSelectController from "./slim_select_controller";
import NestedForm from "@stimulus-components/rails-nested-form";
import { Modal } from "tailwindcss-stimulus-components";
import UpdateLeadController from "./update_lead_controller.js";
import ProspectModalController from "./prospect_modal_controller.js";
import ProspectDashboardController from "./prospect_dashboard_controller.js"
import KanbanController from "./kanban_controller.js";
import ToggleController from "./toggle_controller";
import FileUploadController from "./file_upload_controller";
import FileToggleController from "./file_toggle_controller";
import TaskSelectorController from "./task_selector_controller";
import SidebarController from "./sidebar_controller";
import RailsNestedForm from "@stimulus-components/rails-nested-form";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

application.register("hello", HelloController);
application.register("mask", MaskController);
application.register("quote-form", QuoteFormController);
application.register("react-component", ReactComponentController);
application.register("slim-select", SlimSelectController);
application.register("nested-form", NestedForm);
application.register("modal", Modal);
application.register("update-lead", UpdateLeadController);
application.register("prospect-modal", ProspectModalController);
application.register("prospect-dashboard", ProspectDashboardController);
application.register("kanban", KanbanController);
application.register("toggle", ToggleController);
application.register("file-upload", FileUploadController);
application.register("file-toggle", FileToggleController);
application.register("task-selector", TaskSelectorController);
application.register("sidebar", SidebarController);
application.register("nested-form", RailsNestedForm);
Fancybox.bind("[data-fancybox]", {});
